import React, { createContext, useContext, useState, useEffect } from 'react';
import { executeFetch } from '../Util.js';
import { config } from '../Const.js';

const WeeklyQuizzesContext = createContext();

export const WeeklyQuizzesProvider = ({ children }) => {
    const [assignments, setAssignments] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const loadAssignments = (isInitialLoad = false) => {
        if (isInitialLoad) {
            setLoading(true);
        }
        executeFetch(
            config.SERVER_URL + "/api/v1/admin/weekly-quizzes",
            "get",
            null,
            null,
            null,
            (data) => {
                setAssignments(data);
                setLoading(false);
            },
            (error) => {
                console.error("Failed to load weekly assignments:", error);
                setLoading(false);
            }
        );
    };

    useEffect(() => {
        loadAssignments(true);
    }, []);

    return (
        <WeeklyQuizzesContext.Provider value={{ assignments, setAssignments, loading, saving, setSaving, loadAssignments }}>
            {children}
        </WeeklyQuizzesContext.Provider>
    );
};

export const useWeeklyQuizzes = () => {
    const context = useContext(WeeklyQuizzesContext);
    if (!context) {
        throw new Error('useWeeklyQuizzes must be used within a WeeklyQuizzesProvider');
    }
    return context;
};
